import type {
  PermitGrant,
  PermitGrantData,
  PermitSession,
} from "$apis/parkito2/types.gen.ts";
import api from "$shared/lib/api-parkito2.svelte.ts";

export default class PermitGrantModel implements PermitGrant {
  togglingSession: boolean = $state(false);

  constructor(private grant: PermitGrant) {
  }

  get activeSession(): PermitSession | undefined {
    return this.grant.activeSession ?? undefined;
  }
  get data(): PermitGrantData {
    return this.grant.data;
  }
  get id(): string {
    return this.grant.id;
  }
  get permitId(): string {
    return this.grant.permitId;
  }

  translatedAccessLevel(): string {
    switch (this.grant.data.accessLevel) {
      case "User":
        return "Användare";
      case "Admin":
        return "Admin";
      case "Owner":
        return "Ägare";
    }
  }

  isActive(): boolean {
    return !!this.activeSession;
  }

  async stopSession() {
    this.togglingSession = true;
    const res = await api.permitSessionStop({
      path: {
        grant_id: this.id,
      },
    });
    this.togglingSession = false;
    return res;
  }

  async startSession() {
    if (this.data.licensePlate) {
      this.togglingSession = true;
      const res = await api.permitSessionStart({
        path: {
          grant_id: this.id,
        },
        body: {
          licensePlate: this.data.licensePlate,
        },
      });
      this.togglingSession = false;
      return res;
    } else {
      return { error: "Grant has no licenseplate", data: undefined };
    }
  }

  async toggleSession(): Promise<
    { error: unknown | undefined; data: unknown | undefined }
  > {
    if (this.activeSession) {
      return await this.stopSession();
    } else {
      return await this.startSession();
    }
  }
}
